import obelisk from '../clients/obelisk';
import pillars from '../clients/pillars';
import PropTypes from 'prop-types';

/**
 * Fetches product data from Pillars API.
 * @param {number} count The number of products to fetch.
 * @returns {Promise<Object>} The product data.
 */
export const ProductsGetService = async (count = 500) =>
  await pillars().get('Products', { count });

ProductsGetService.propTypes = {
  count: PropTypes.number,
};

// Fetches products and then removes any products that don't have prices
export const ProductsGetFilteredService = async ({
  storeId,
  userType,
  currencyCode,
  regionId,
}) => {
  const resp = await obelisk()
    .post('Product/GetProducts', {
      storeId,
      userType,
      currencyCode,
      regionId,
    })
    .then((r) => {
      return r.data?.products;
    });
  if (!resp) {
    throw new Error('No products found');
  }
  const filtered =
    resp?.filter((p) => {
      return p?.prices?.length > 0;
    }) || [];
  return { items: filtered, count: filtered.length };
};

ProductsGetFilteredService.propTypes = {
  storeId: PropTypes.string.isRequired,
  userType: PropTypes.string,
  currencyCode: PropTypes.string,
  regionId: PropTypes.string,
};

/**
 * Fetches subscription products from Pillars API.
 * @returns {Promise<Object>} The subscription data.
 */
export const SubscriptionProductsGetService = async () =>
  await obelisk().get('Subscription/GetSubscription');
